import { render, staticRenderFns } from "./menu-function.vue?vue&type=template&id=f3db65e8"
import script from "./menu-function.vue?vue&type=script&lang=js"
export * from "./menu-function.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports